/*
* Check if a game is being hosted by Y8 to disable links to Y8.
* Also, check if a site has been blacklisted.
*/
define('protection',['utils/domain', 'sdk/api', 'logger'],
function(Domain, API, Logger) {
  var domain = Domain.getDomain();
  var approved = [];
  var blacklist = [];
  var sponsor = null;
  var blacklisted = null;
  var timeout = null;

  var runChecks = function(callback) {
    if (approved.length === 0) {
      API.apiOpen('protection-lists', 'GET', null, function(data) {
        if (data.hasOwnProperty('approved_domains')) {
          approved = data.approved_domains;
          blacklist = data.blacklisted_urls;
          clearTimeout(timeout);
        }
        callback();
      });

      timeout = setTimeout(function() {
        callback();
      }, 10000); // 10 seconds
    } else {
      callback();
    }
  };

  return {
    isSponsor: function(callback) {
      if (sponsor) {
        callback(sponsor);
        return;
      }

      runChecks(function() {
        for (var i = 0; i < approved.length; i++) {
          if (domain.search(approved[i]) != -1) {
            sponsor = true;
            callback(true);
            return;
          }
        }

        sponsor = false;
        callback(false);
      });
    },

    isBlacklisted: function(callback) {
      if (blacklisted) {
        callback(blacklisted);
        return;
      }

      runChecks(function() {
        for (var i = 0; i < blacklist.length; i++) {
          if (domain.search(blacklist[i]) != -1) {
            blacklisted = true;
            callback(true);
            return;
          }
        }

        blacklisted = false;
        callback(false);
      });
    },

    debug: function() {
      Logger.log('domain ' + domain);
      Logger.log('approved', approved);
      Logger.log('blacklist', blacklist);
      for (var i = 0; i < blacklist.length; i++) {
        Logger.log(domain.search(blacklist[i]) != -1);
      }

      Logger.log('---');
      for (var i = 0; i < approved.length; i++) {
        Logger.log(domain.search(approved[i]) != -1);
      }
    },
  };
});

